import { ControlModes } from '@src/types/Stacks';

export const updateFieldValue = (
  controlModes: ControlModes[],
  controlModeIndex: number,
  sectionIndex: number,
  fieldIndex: number,
  newValue: string | number | boolean | null,
): ControlModes[] => {
  const updatedControlModes = [...controlModes];

  // Ensure all indices are valid
  if (
    controlModeIndex >= 0 &&
    controlModeIndex < updatedControlModes.length &&
    sectionIndex >= 0 &&
    sectionIndex < updatedControlModes[controlModeIndex].sections.length &&
    fieldIndex >= 0 &&
    fieldIndex <
      updatedControlModes[controlModeIndex].sections[sectionIndex].fields.length
  ) {
    // Handle null value by converting to appropriate default based on field type
    const field =
      updatedControlModes[controlModeIndex].sections[sectionIndex].fields[
        fieldIndex
      ];
    if (newValue === null) {
      if (field.type === 'number') {
        field.value = 0;
      } else if (field.type === 'boolean') {
        field.value = false;
      } else {
        // For string and select types
        field.value = '';
      }
    } else {
      field.value = newValue;
    }
  }

  return updatedControlModes;
};

export const deleteField = (
  controlModes: ControlModes[],
  controlModeIndex: number,
  sectionIndex: number,
  fieldIndex: number,
): ControlModes[] => {
  const updatedControlModes = [...controlModes];

  // Ensure all indices are valid
  if (
    controlModeIndex >= 0 &&
    controlModeIndex < updatedControlModes.length &&
    sectionIndex >= 0 &&
    sectionIndex < updatedControlModes[controlModeIndex].sections.length &&
    fieldIndex >= 0 &&
    fieldIndex <
      updatedControlModes[controlModeIndex].sections[sectionIndex].fields.length
  ) {
    // Remove the field from the section
    updatedControlModes[controlModeIndex].sections[sectionIndex].fields.splice(
      fieldIndex,
      1,
    );
  }

  return updatedControlModes;
};

export const deleteSection = (
  controlModes: ControlModes[],
  controlModeIndex: number,
  sectionIndex: number,
): ControlModes[] => {
  const updatedControlModes = [...controlModes];

  // Ensure all indices are valid
  if (
    controlModeIndex >= 0 &&
    controlModeIndex < updatedControlModes.length &&
    sectionIndex >= 0 &&
    sectionIndex < updatedControlModes[controlModeIndex].sections.length
  ) {
    // Remove the section from the control mode
    updatedControlModes[controlModeIndex].sections.splice(sectionIndex, 1);
  }

  return updatedControlModes;
};
